import ChatService from "../../../front-services/ChatService";
import { useSliderState } from "./slider/SliderState";
import Analytics from "../../../utils/Analytics";
import localization from "../../../assets/localization";
import ResponsiveImage from "./slider/templates/utils/ResponsiveImage";

export default function ImageSlideShow({
  images,
  title,
  imageIndex,
  setImageIndex,
  roomTransitionFade,
  shouldShowAvailable = true,
}: any) {
  const sliderState = useSliderState();

  // In-gallery browsing is local state, invisible to the store — log which
  // photo the guest lands on. Crossing into the next/previous gallery goes
  // through the store, which already logs its own item_view.
  const trackImage = (index: number) => {
    Analytics.track("item_view", {
      template_type: sliderState.currentTemplate?.type ?? null,
      item_index: sliderState.subTemplateItemIndex,
      item_title: images?.[index]?.title || title || null,
      image_index: index,
      source: "gallery_image",
    });
  };

  const goToPrevious = () => {
    if (imageIndex === 0) {
      sliderState.previous();
      setImageIndex(images.length - 1);
      return;
    }

    const next = imageIndex === 0 ? images.length - 1 : imageIndex - 1;
    trackImage(next);
    setImageIndex(next);
  };

  const goToNext = () => {
    if (imageIndex === images.length - 1) {
      sliderState.next();
      setImageIndex(0);
      return;
    }
    const next = (imageIndex + 1) % images.length;
    trackImage(next);
    setImageIndex(next);
  };

  const goToSlide = (index: number) => {
    if (index !== imageIndex) trackImage(index);
    setImageIndex(index);
  };
  return (
    <>
      {/* Image */}
      {images &&
        images.map((image: any, index: any) => (
          <ResponsiveImage
            key={index}
            src={image.image_url ?? image.url}
            alt={image.description ?? ""}
            className="image-slideshow-item"
            style={{
              opacity: index === imageIndex ? 1 : 0,
              transition: "opacity 0.8s ease-in-out",
              transform: ChatService.isHM(sliderState.assistantId)
                ? undefined
                : "scale(1.5)",
            }}
          />
        ))}

      {/* Navigation buttons */}
      <button
        onClick={goToPrevious}
        className="image-slideshow-navigation-button"
        style={{
          left: "5px",
        }}
      >
        <i className="fa-solid fa-chevron-left"></i>
      </button>
      <button
        onClick={goToNext}
        className="image-slideshow-navigation-button"
        style={{
          right: "5px",
        }}
      >
        <i className="fa-solid fa-chevron-right"></i>
      </button>

      {/* Dots navigation */}
      <div className="image-slideshow-dot-container">
        {images.map((_: any, index: any) => (
          <div
            key={index}
            onClick={() => goToSlide(index)}
            className="image-slideshow-dot"
            style={{
              backgroundColor:
                index === imageIndex ? "var(--primary-color)" : "#fff",
              opacity: index === imageIndex ? 1 : 0.5,
            }}
          />
        ))}
      </div>

      <div
        className="image-slideshow-title-box"
        style={{
          opacity: roomTransitionFade ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
        }}
      >
        <div className="image-slideshow-title">{title}</div>
        {shouldShowAvailable && (
          <div className="image-slideshow-subtitle">{localization.get(sliderState.language).available}</div>
        )}
      </div>
    </>
  );
}
